/* eslint-disable max-classes-per-file */
import { SimpleSelectionItem } from "~app/common/components/selector/simple-selection-item";
import { SkogsvardAtgardsGrupp, SkogsvardBetalningstyp, SkogsvardMattslagsTyper } from "~app/common/models/constants";

import { Atgard } from "../atgard-models";
import { IAtgardstypWithGroup } from "../atgardstyp-with-group-dto";
import { Planeringsstatus } from "../planeringsstatus";

export class VKAtgardSkogsvardTradslagDTO {
    id?: number;
    tradslagId?: number;
    antalPlantor?: number;
    frogiva?: number;
    arealandel?: number;
    sekvensnummer: number;
    guid: string;
    tag: VKAtgardSkogsvardTradslagDTO;
}

export class AtgardSkogsvardTradslag extends VKAtgardSkogsvardTradslagDTO {
    id?: number;
    guid: string;
    tradslagId?: number;
    antalPlantor?: number;
    frogiva?: number;
    arealandel?: number;
    sekvensnummer: number;
    tag: VKAtgardSkogsvardTradslagDTO;

    constructor(atgTrad: VKAtgardSkogsvardTradslagDTO) {
        super();
        this.id = atgTrad?.id;
        this.guid = atgTrad?.guid;
        this.tradslagId = atgTrad?.tradslagId;
        this.antalPlantor = atgTrad?.antalPlantor;
        this.frogiva = atgTrad?.frogiva;
        this.sekvensnummer = atgTrad?.sekvensnummer;
        this.tag = atgTrad?.tag;
        this.arealandel = atgTrad?.arealandel;
    }
}

export class VKAtgardRojningTradskiktDTO {
    id?: number;
    guid: string;
    matdatum?: string;
    mattillfalle: string;
    tradslag?: VKAtgardRojningTradslagDTO[];
}

export class VKAtgardRojningTradskikt extends VKAtgardRojningTradskiktDTO {
    id?: number;
    guid: string;
    matdatum?: string;
    mattillfalle: string;
    tradslag?: VKAtgardRojningTradslag[];

    constructor(rojTradskikt: VKAtgardRojningTradskiktDTO) {
        super();
        this.id = rojTradskikt?.id;
        this.guid = rojTradskikt?.guid;
        this.matdatum = rojTradskikt?.matdatum;
        this.mattillfalle = rojTradskikt?.mattillfalle;
        this.tradslag = rojTradskikt?.tradslag;
    }
}

export class VKAtgardRojningTradslagDTO {
    id?: number;
    guid: string;
    tradslagId?: number;
    tradhojd?: number;
    antalHa?: number;
    sekvensnummer?: number;
}

export class VKAtgardRojningTradslag extends VKAtgardRojningTradslagDTO {
    id?: number;
    guid: string;
    tradslagId?: number;
    tradhojd?: number;
    antalHa?: number;
    sekvensnummer?: number;

    constructor(rojTrad: VKAtgardRojningTradslagDTO) {
        super();
        this.id = rojTrad?.id;
        this.guid = rojTrad?.guid;
        this.tradslagId = rojTrad?.tradslagId;
        this.tradhojd = rojTrad?.tradhojd;
        this.antalHa = rojTrad?.antalHa;
        this.sekvensnummer = rojTrad?.sekvensnummer;
    }
}

export interface VKAtgardSkogsvardTradslagPlantorDTO {
    id?: number;
    guid: string;
    tradslagId?: number;
    planttyp: string;
    plantantal?: number;
    arealandel?: number;
    malPlantorHA?: number;
    plantskydd: string;
    sekvensnummer: number;
}

export class AtgardSkogsvardTradslagPlanta implements VKAtgardSkogsvardTradslagPlantorDTO {
    id?: number;
    guid: string;
    tradslagId?: number;
    planttyp: string;
    plantantal?: number;
    arealandel?: number;
    malPlantorHA?: number;
    plantskydd: string;
    sekvensnummer: number;

    constructor(atgTrad: VKAtgardSkogsvardTradslagPlantorDTO) {
        this.id = atgTrad?.id;
        this.guid = atgTrad?.guid;
        this.tradslagId = atgTrad?.tradslagId;
        this.planttyp = atgTrad?.planttyp;
        this.plantantal = atgTrad?.plantantal;
        this.arealandel = atgTrad?.arealandel;
        this.plantskydd = atgTrad?.plantskydd;
        this.sekvensnummer = atgTrad?.sekvensnummer;
    }
}

export class SkogsvardstypWithGroupDTO implements IAtgardstypWithGroup {
    namn: string;
    kortnamn: string;
    grupp: string;
}

export class VKKontraktSkogsvardBetalningDTO {
    id?: number;
    virkeskopskontraktId: number;
    atgardsGrupp?: string;
    betalningstyp?: string;
    atgardstypVacs?: string;
    kvantitet?: number;
    mattslag?: string;
    apris?: number;
    anteckningIntern?: string;
    datumTillagd?: Date;
    skickadTillVacs?: Date;
    rowVersion?: string;
    canOnlySetBetaltypFaktura: boolean;
    belopp?: number;
    canChangeMattslag: boolean;
    virkeskopsatgardId?: number;
    virkeskopsatgardBeteckning?: string;
    kontrakteratApris?: number;
    kontrakteradKvantitet?: number;
    kontrakteratBelopp?: number;
    slutjusterad?: boolean;
}

export class KontraktSkogsvardBetalning extends VKKontraktSkogsvardBetalningDTO {
    id?: number;
    virkeskopskontraktId: number;
    atgardsGrupp?: string;
    betalningstyp?: string;
    atgardstypVacs?: string;
    kvantitet?: number;
    mattslag?: string;
    apris?: number;
    anteckningIntern?: string;
    datumTillagd?: Date;
    skickadTillVacs?: Date;
    rowVersion?: string;
    canOnlySetBetaltypFaktura: boolean;
    belopp?: number;
    canChangeMattslag: boolean;
    virkeskopsatgardId?: number;
    virkeskopsatgardBeteckning?: string;
    kontrakteratApris?: number;
    kontrakteradKvantitet?: number;
    kontrakteratBelopp?: number;
    slutjusterad?: boolean;

    constructor(bet: VKKontraktSkogsvardBetalningDTO) {
        super();
        this.id = bet.id;
        this.virkeskopskontraktId = bet.virkeskopskontraktId;
        this.atgardsGrupp = bet.atgardsGrupp;
        this.betalningstyp = bet.betalningstyp;
        this.atgardstypVacs = bet.atgardstypVacs;
        this.kvantitet = bet.kvantitet;
        this.mattslag = bet.mattslag;
        this.apris = bet.apris;
        this.anteckningIntern = bet.anteckningIntern;
        this.datumTillagd = bet.datumTillagd;
        this.skickadTillVacs = bet.skickadTillVacs;
        this.rowVersion = bet.rowVersion;
        this.canOnlySetBetaltypFaktura = bet.canOnlySetBetaltypFaktura;
        this.belopp = bet.belopp;
        this.canChangeMattslag = bet.canChangeMattslag;
        this.virkeskopsatgardId = bet.virkeskopsatgardId;
        this.virkeskopsatgardBeteckning = bet.virkeskopsatgardBeteckning;
        this.kontrakteradKvantitet = bet.kontrakteradKvantitet;
        this.kontrakteratApris = bet.kontrakteratApris;
        this.kontrakteratBelopp = bet.kontrakteratBelopp;
        this.slutjusterad = bet.slutjusterad;
    }
}

export interface IKontraktSkogsvardBetalningTableRow extends KontraktSkogsvardBetalning {
    cssClass?: string;
    canChangeRow: boolean;
    canChangeMattslag: boolean;
    canChangeBelopp: boolean;
    isKreditbetalning: boolean;
    isFirstVacsRad: boolean;
    isFirstOfType: boolean;
    hasConnectedAtgard: boolean;
    isVacsRad: boolean;
    hasKontrakteradeValues: boolean;
    betalningSelectItems: SimpleSelectionItem[];
    betalformDisabled: boolean;
    calculateBelopp: boolean;
    hideKvantitet: boolean;
    justeringMojlig: boolean;
    kontrakteratKvantitetCssClass?: string;
    kontrakteratAprisCssClass?: string;
    kontrakteratBeloppCssClass?: string;
}

export class KontraktSkogsvardBetalningTableRow implements IKontraktSkogsvardBetalningTableRow {
    cssClass?: string;
    canChangeRow: boolean;
    canChangeMattslag: boolean;
    canChangeBelopp: boolean;
    isKreditbetalning: boolean;
    isFirstVacsRad: boolean;
    isFirstOfType: boolean;
    hasConnectedAtgard: boolean;
    isVacsRad: boolean;
    betalningSelectItems: SimpleSelectionItem[];
    betalformDisabled: boolean;
    calculateBelopp: boolean;
    hideKvantitet: boolean;
    justeringMojlig: boolean;
    slutjusterad: boolean;
    hasKontrakteradeValues: boolean;

    id?: number;
    virkeskopskontraktId: number;
    atgardsGrupp?: string;
    betalningstyp?: string;
    atgardstypVacs?: string;
    kvantitet?: number;
    mattslag?: string;
    apris?: number;
    anteckningIntern?: string;
    datumTillagd?: Date;
    skickadTillVacs?: Date;
    rowVersion?: string;
    canOnlySetBetaltypFaktura: boolean;
    belopp?: number;
    virkeskopsatgardId?: number;
    virkeskopsatgardBeteckning?: string;
    kontrakteratKvantitetIdentisk: boolean;
    kontrakteratAprisIdentisk: boolean;
    kontrakteratBeloppIdentisk: boolean;
    kontrakteratApris?: number;
    kontrakteradKvantitet?: number;
    kontrakteratBelopp?: number;

    static readonly SELECT_ALL: SimpleSelectionItem[] = [
        {
            id: SkogsvardBetalningstyp.likvid,
            value: SkogsvardBetalningstyp.likvid,
            text: "Likvid"
        },
        {
            id: SkogsvardBetalningstyp.faktura,
            value: SkogsvardBetalningstyp.faktura,
            text: "Faktura"
        }
    ];

    static readonly SELECT_FAKTURA: SimpleSelectionItem[] = [
        {
            id: SkogsvardBetalningstyp.faktura,
            value: SkogsvardBetalningstyp.faktura,
            text: "Faktura"
        }
    ];

    constructor(
        betalningRow: KontraktSkogsvardBetalning,
        ctx: {
            skogsvardsAtgarder: Atgard[];
            allaBetalningar: KontraktSkogsvardBetalning[];
            firstVacsRowFound: boolean;
            firstFoundPerType: Set<string>;
            avslutatAvraknat: boolean;
            legacySkogsvardBetalraderLocked: boolean;
        }
    ) {
        Object.assign(this, betalningRow);
        this.isKreditbetalning = this.apris < 0;
        this.setRowDefaultValues(this);

        const rowContext = this.computeRowContext(ctx);
        this.setFirstVacsRow(ctx);
        this.setEditability(rowContext, ctx.legacySkogsvardBetalraderLocked);
        this.setMattslagDerivedFields();

        this.betalningSelectItems = KontraktSkogsvardBetalningTableRow.computeBetalningSelectItems(
            this,
            ctx.avslutatAvraknat
        );
        this.cssClass = KontraktSkogsvardBetalningTableRow.computeCssClass(this, ctx.legacySkogsvardBetalraderLocked);
        this.betalformDisabled = KontraktSkogsvardBetalningTableRow.computeDisabled(this);
    }

    static shouldHandleBelopp(betalning: KontraktSkogsvardBetalning): boolean {
        return betalning.canChangeMattslag &&
            betalning.betalningstyp === SkogsvardBetalningstyp.likvid &&
            betalning.mattslag === SkogsvardMattslagsTyper.timme;
    }

    static shouldHideKvantitetTableRow(item: IKontraktSkogsvardBetalningTableRow): boolean {
        return (
            item.justeringMojlig &&
            item.mattslag === SkogsvardMattslagsTyper.timme &&
            item.betalningstyp === SkogsvardBetalningstyp.likvid
        ) || (!item.justeringMojlig && item.mattslag === SkogsvardMattslagsTyper.timme);
    }

    static computeCssClass(row: IKontraktSkogsvardBetalningTableRow, kontraktLegacyLocked: boolean): string {
        const cssClasses: string[] = [];
        if(row.hasConnectedAtgard) {
            // Betalraden är av nya typen och har egna css regler.
            // cssClasses.push("skogsvard-betalning2");
            if(row.slutjusterad || kontraktLegacyLocked) {
                cssClasses.push("skogsvard-betalning-slutjusterad");
            }else if (row.justeringMojlig) {
                cssClasses.push("skogsvard-betalning-justering");
            }
        } else {
            if (row.isVacsRad) {
                if (row.isFirstVacsRad) {
                    cssClasses.push("skogsvard-betalning-skickad-till-vacs-overst");
                }
                cssClasses.push("skogsvard-betalning-redan-skickad-till-vacs");
            }
            if (row.apris < 0) {
                cssClasses.push("skogsvard-betalning-kredit");
            }
            if (row.justeringMojlig) {
                cssClasses.push("skogsvard-betalning-justering");
            }
        }
        return cssClasses.join(" ");
    }

    static computeBetalningSelectItems(
        item: IKontraktSkogsvardBetalningTableRow,
        avslutatAvraknat: boolean
    ): SimpleSelectionItem[] {
        const selectAlla = KontraktSkogsvardBetalningTableRow.SELECT_ALL;
        const selectFaktura = KontraktSkogsvardBetalningTableRow.SELECT_FAKTURA;
        if (avslutatAvraknat && item.betalningstyp && item.betalningstyp === SkogsvardBetalningstyp.likvid) {
            return selectAlla;
        } else if (avslutatAvraknat) {
            return selectFaktura;
        } else if (item.canOnlySetBetaltypFaktura) {
            if (item.betalningstyp && item.betalningstyp === SkogsvardBetalningstyp.likvid) {
                return selectAlla;
            } else {
                return selectFaktura;
            }
        }
        return selectAlla;
    }

    static computeDisabled(row: IKontraktSkogsvardBetalningTableRow): boolean {
        return !!(row.canOnlySetBetaltypFaktura &&
            row.betalningstyp &&
            row.betalningSelectItems &&
            row.betalningSelectItems.length === 1 &&
            row.betalningSelectItems[0].value === SkogsvardBetalningstyp.faktura);
    }

    /**
     * Skapar en unik nyckel för att identifiera betalningsrader per atgardstypVacs och virkeskopsatgardId.
     * För legacy-rader (utan virkeskopsatgardId) används endast atgardstypVacs.
     */
    static getBetalningKey(atgardstypVacs: string | undefined, virkeskopsatgardId: number | undefined): string {
        return virkeskopsatgardId
            ? `${atgardstypVacs ?? ""}_${virkeskopsatgardId}`
            : atgardstypVacs ?? "";
    }

    /**
     * Kontrollerar om två betalningsrader matchar på atgardstypVacs och virkeskopsatgardId.
     */
    static isSameBetalningType(row1: KontraktSkogsvardBetalning, row2: KontraktSkogsvardBetalning): boolean {
        return KontraktSkogsvardBetalningTableRow.getBetalningKey(row1.atgardstypVacs, row1.virkeskopsatgardId) ===
            KontraktSkogsvardBetalningTableRow.getBetalningKey(row2.atgardstypVacs, row2.virkeskopsatgardId);
    }

    private computeRowContext(ctx: {
        skogsvardsAtgarder: Atgard[];
        allaBetalningar: KontraktSkogsvardBetalning[];
        firstFoundPerType: Set<string>;
    }) {
        const filteredAtgarder = ctx.skogsvardsAtgarder.filter(a => SkogsvardAtgardsGrupp.matchesGrupp(a.atgardsgrupp, this.atgardsGrupp));
        const isGruppJusterbar = filteredAtgarder.length !== 0 && filteredAtgarder.every(a => a.isBetalningJusterbar);

        const isRowJusterbar = this.virkeskopsatgardId
            ? !!ctx.skogsvardsAtgarder.find(a => a.id === this.virkeskopsatgardId)?.isBetalningJusterbar
            : isGruppJusterbar;

        const thisDate = this.skickadTillVacs ?? this.datumTillagd;

        // Kolla om det finns nyare kreditrad för samma typ OCH åtgärdsid
        const existsNewerCreditRowForType = this.isVacsRad && ctx.allaBetalningar.some(b =>
            b.id !== this.id &&
            b.apris < 0 &&
            (b.skickadTillVacs ?? b.datumTillagd) > thisDate &&
            KontraktSkogsvardBetalningTableRow.isSameBetalningType(this, b)
        );

        //Markerar första raden av varje typ och åtgärdsid så endast dessa har edit-knapparna på sig
        const key = KontraktSkogsvardBetalningTableRow.getBetalningKey(this.atgardstypVacs, this.virkeskopsatgardId);
        if (!ctx.firstFoundPerType.has(key)) {
            this.isFirstOfType = true;
            ctx.firstFoundPerType.add(key);
        } else {
            this.isFirstOfType = false;
        }

        return {
            existsNewerCreditRowForType,
            isRowJusterbar
        };
    }

    private setFirstVacsRow(ctx: { firstVacsRowFound: boolean }) {
        // isFirstVacsRad - global för styling (endast en rad per grupp ska ha "överst"-stylingen)
        if (!this.hasConnectedAtgard && this.isVacsRad && !ctx.firstVacsRowFound) {
            this.isFirstVacsRad = true;
            ctx.firstVacsRowFound = true;
        } else {
            this.isFirstVacsRad = false;
        }
    }

    private setEditability(rowContext: {
        existsNewerCreditRowForType: boolean;
        isRowJusterbar: boolean;
    }, kontraktLegacyLocked: boolean) {
        // Tillåt inga ändringar på legacy rader, de borde alla blivit migrerade eller satta till låsta.
        if(!this.hasConnectedAtgard) {
            return;
        }
        if(rowContext.isRowJusterbar && !kontraktLegacyLocked) {
            this.justeringMojlig = !this.slutjusterad;
        } else if(!this.isKreditbetalning && !rowContext.existsNewerCreditRowForType && this.isFirstOfType && !kontraktLegacyLocked) {
            this.canChangeRow = true;
        }
    }

    private setMattslagDerivedFields() {
        if (this.canChangeMattslag) {
            this.canChangeBelopp = (this.canChangeRow || this.justeringMojlig) &&
                KontraktSkogsvardBetalningTableRow.shouldHandleBelopp(this);
            this.calculateBelopp = !(this.mattslag === SkogsvardMattslagsTyper.timme && this.betalningstyp === SkogsvardBetalningstyp.likvid);
            this.hideKvantitet = KontraktSkogsvardBetalningTableRow.shouldHideKvantitetTableRow(this);
        }
    }

    private setRowDefaultValues(row: IKontraktSkogsvardBetalningTableRow) {
        row.canChangeRow = false;
        row.canChangeBelopp = false;
        row.calculateBelopp = true;
        row.hideKvantitet = false;
        row.justeringMojlig = false;
        row.isFirstVacsRad = false;
        row.isFirstOfType = false;
        row.hasKontrakteradeValues = !!row.kontrakteradKvantitet || !!row.kontrakteratApris || !!row.kontrakteratBelopp;
        row.isVacsRad = !!row.skickadTillVacs;
        row.hasConnectedAtgard = !!row.virkeskopsatgardId;
        row.kontrakteratKvantitetCssClass = row.kontrakteradKvantitet === row.kvantitet ? "" : "betalrad-kontrakerat-differs";
        row.kontrakteratAprisCssClass = row.kontrakteratApris === row.apris ? "" : "betalrad-kontrakerat-differs";
        row.kontrakteratBeloppCssClass = (!!row.kontrakteratBelopp && row.kontrakteratBelopp === row.belopp) ? "" : "betalrad-kontrakerat-differs";
    }
}

export interface IBetalningSkogsvardGrupp {
    sekvensnummer: number;
    atgardsGrupp: string;
}

export const SKOGSVARD_PLANERINGSSTATUS = [
    Planeringsstatus.UnderPlanering,
    Planeringsstatus.Tillgangligt
];
